'use client';

import { ComponentProps, ReactNode, useId, useMemo } from 'react';

import { cx } from '../cva';
import { FieldContext, FieldContextValue } from './context';

export type FieldProps = ComponentProps<'div'> &
    Partial<FieldContextValue> & {
        children: ReactNode;
    };

export function Field({
    children,
    className,
    error,
    id: idProp,
    name,
    required,
    ...props
}: FieldProps) {
    const id = useId();

    const value = useMemo(
        () => ({
            error,
            id: idProp ?? id,
            name,
            required,
        }),
        [error, id, idProp, name, required]
    );

    return (
        <FieldContext value={value}>
            <div
                className={cx('flex flex-col items-stretch gap-1', className)}
                {...props}
            >
                {children}
            </div>
        </FieldContext>
    );
}
